var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var QuestionIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 36,
    glyphHeight: 54
  }), React.createElement("path", {
    d: "M11.7826 36.1391V24.6608C19.713 24.4521 23.6782 22.1565 23.6782 16.7304V15.6869C23.6782 11.9304 21.1739 9.84345 17.6261 9.84345C13.6609 9.84345 11.1565 12.5565 10.113 16.313L0.93042 12.5565C2.59999 6.50432 7.60868 0.452148 17.8348 0.452148C28.0609 0.452148 35.3652 6.71302 35.3652 15.8956C35.3652 24.2435 29.313 29.6695 22.2174 30.9217V36.3478H11.7826V36.1391Z"
  }), React.createElement("path", {
    d: "M17 53.0432C20.4578 53.0432 23.2609 50.2401 23.2609 46.7824C23.2609 43.3246 20.4578 40.5215 17 40.5215C13.5422 40.5215 10.7391 43.3246 10.7391 46.7824C10.7391 50.2401 13.5422 53.0432 17 53.0432Z"
  }));
};
export var QuestionIconGlyph = function (props) {
  return React.createElement(QuestionIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};